export default __webpack_public_path__ + "static/media/img-8.3817177b.jpg";